import { useSnackbar, OptionsObject } from 'notistack';
import { ApolloError } from '@apollo/client';

type OmittedOptionsObject = Omit<OptionsObject, 'variant'>;

export const FrequentUsedOptions = {
  Bottom: {
    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
    style: { top: 0 },
  },
} as const;

export const useCustomSnackBar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  return {
    enqueueSuccessSnackbar: (message: string, overwriteOptions?: OmittedOptionsObject) =>
      enqueueSnackbar(message, {
        variant: 'success',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        ...overwriteOptions,
      }),
    enqueueErrorSnackbar: (messageOrError: string | Error, overwriteOptions?: OmittedOptionsObject) =>
      enqueueSnackbar(getErrorMessage(messageOrError), {
        variant: 'error',
        persist: true,
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        ...overwriteOptions,
      }),
    enqueueInfoSnackbar: (message: string, overwriteOptions?: OmittedOptionsObject) =>
      enqueueSnackbar(message, {
        variant: 'info',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        ...overwriteOptions,
      }),
    closeSnackbar: (key?: string) => closeSnackbar(key),
  };
};

const getErrorMessage = (messageOrError: string | Error): string => {
  if (typeof messageOrError == 'string') {
    return messageOrError;
  }
  const error: Error = messageOrError;
  if (error instanceof ApolloError) {
    if (error.graphQLErrors.length > 0) {
      return error.graphQLErrors[0].message;
    }
    if (error.clientErrors.length > 0) {
      return error.clientErrors[0].message;
    }
    if (error.networkError != null) {
      return error.networkError.message;
    }
    return error.message;
  }
  return error.message;
};
